import { createGlobalStyle, css } from 'styled-components';

const RegisterPopupStyle = createGlobalStyle`${css`
	:root {
		--registerPopupTitleMargin: var(--sp4x) 0 var(--sp4x) 0;
		--registerPopupSubtitleMarginBottom: var(--sp2-5x);
		--registerPopupDescriptionMarginBottom: var(--sp3x);
		--registerPopupContainerPadding: 0 var(--sp11x);
		--registerPopupFormItemMarginTop: var(--sp6x);
		--registerPopupCheckboxSize: var(--sp3x);
		--registerPopupCheckboxWrapMarginTop: var(--sp6x);
		--registerPopupCheckboxMarginRight: var(--sp2x);
		--registerPopupCheckIconSize: var(--sp1-5x);
		--registerPopupBtnMargin: var(--sp7x) 0 var(--sp11x) 0;
	}

	.popup-title {
		margin: var(--registerPopupTitleMargin);
		text-align: center;
	}
	.popup-subtitle {
		margin-bottom: var(--registerPopupSubtitleMarginBottom);
		text-align: center;
	}
	.popup-description {
		margin-bottom: var(--registerPopupDescriptionMarginBottom);
		text-align: center;
	}

	.register-popup-cont {
		padding: var(--registerPopupContainerPadding) !important;

		.checkbox-warp {
			display: flex;
			align-items: center;
			margin-top: var(--registerPopupCheckboxWrapMarginTop);
			cursor: pointer;
			width: fit-content;

			.checkbox {
				display: flex;
				justify-content: center;
				align-items: center;
				width: var(--registerPopupCheckboxSize);
				height: var(--registerPopupCheckboxSize);
				margin-right: var(--registerPopupCheckboxMarginRight);
				border: 1px solid black;
				border-radius: var(--sp0-5x);
				cursor: pointer;

				.check-icon {
					font-size: var(--registerPopupCheckIconSize);
				}

				&.active {
					border: 1px solid var(--primaryColor2);
					background-color: var(--primaryColor2);
				}
			}
		}

		.register-btn {
			display: flex;
			justify-content: flex-end;
		}
	}

	.from-item {
		margin-top: var(--registerPopupFormItemMarginTop);

		.ant-form-item {
			margin-bottom: 0;
		}
	}

	.register-buttons-wrap {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin: var(--registerPopupBtnMargin);
	}

	.sign-in {
		cursor: pointer;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		:root {
			--registerPopupTitleMargin: var(--sp3x) 0;
			--registerPopupSubtitleMarginBottom: var(--sp2x);
			--registerPopupDescriptionMarginBottom: var(--sp1x);
			--registerPopupContainerPadding: 0 var(--sp10x);
			--registerPopupFormItemMarginTop: var(--sp5x);
			--registerPopupCheckboxSize: var(--sp3x);
			--registerPopupCheckboxWrapMarginTop: var(--sp5x);
			--registerPopupCheckboxMarginRight: var(--sp2x);
			--registerPopupCheckIconSize: var(--sp1-5x);
			--registerPopupBtnMargin: var(--sp6x) 0 var(--sp9x) 0;
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		:root {
			--registerPopupTitleMargin: var(--sp2x) 0;
			--registerPopupSubtitleMarginBottom: var(--sp1x);
			--registerPopupDescriptionMarginBottom: var(--sp1x);
			--registerPopupContainerPadding: 0 var(--sp9x);
			--registerPopupFormItemMarginTop: var(--sp3x);
			--registerPopupCheckboxSize: var(--sp3x);
			--registerPopupCheckboxWrapMarginTop: var(--sp3x);
			--registerPopupCheckboxMarginRight: var(--sp1x);
			--registerPopupCheckIconSize: var(--sp1-5x);
			--registerPopupBtnMargin: var(--sp4x) 0 var(--sp7x) 0;
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		:root {
			--registerPopupTitleMargin: var(--sp2x) 0;
			--registerPopupSubtitleMarginBottom: var(--sp1x);
			--registerPopupDescriptionMarginBottom: var(--sp1x);
			--registerPopupContainerPadding: 0 var(--sp8x);
			--registerPopupFormItemMarginTop: var(--sp3x);
			--registerPopupCheckboxSize: var(--sp3x);
			--registerPopupCheckboxWrapMarginTop: var(--sp3x);
			--registerPopupCheckboxMarginRight: var(--sp1x);
			--registerPopupCheckIconSize: var(--sp1-5x);
			--registerPopupBtnMargin: var(--sp4x) 0 var(--sp7x) 0;
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		:root {
			--registerPopupTitleMargin: var(--sp2x) 0;
			--registerPopupSubtitleMarginBottom: var(--sp1x);
			--registerPopupDescriptionMarginBottom: var(--sp1x);
			--registerPopupContainerPadding: 0 var(--sp8x);
			--registerPopupFormItemMarginTop: var(--sp3x);
			--registerPopupCheckboxSize: var(--sp3x);
			--registerPopupCheckboxWrapMarginTop: var(--sp3x);
			--registerPopupCheckboxMarginRight: var(--sp1x);
			--registerPopupCheckIconSize: var(--sp1-5x);
			--registerPopupBtnMargin: var(--sp4x) 0 var(--sp7x) 0;
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		:root {
			--registerPopupTitleMargin: var(--sp2x) 0;
			--registerPopupSubtitleMarginBottom: var(--sp1x);
			--registerPopupDescriptionMarginBottom: var(--sp1x);
			--registerPopupContainerPadding: 0 var(--sp5x);
			--registerPopupFormItemMarginTop: var(--sp3x);
			--registerPopupCheckboxSize: var(--sp3x);
			--registerPopupCheckboxWrapMarginTop: var(--sp3x);
			--registerPopupCheckboxMarginRight: var(--sp1x);
			--registerPopupCheckIconSize: var(--sp1-5x);
			--registerPopupBtnMargin: var(--sp4x) 0 var(--sp7x) 0;
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		:root {
			--registerPopupTitleMargin: var(--sp2x) 0;
			--registerPopupSubtitleMarginBottom: var(--sp1x);
			--registerPopupDescriptionMarginBottom: var(--sp1x);
			--registerPopupContainerPadding: 0 var(--sp5x);
			--registerPopupFormItemMarginTop: var(--sp3x);
			--registerPopupCheckboxSize: var(--sp3x);
			--registerPopupCheckboxWrapMarginTop: var(--sp3x);
			--registerPopupCheckboxMarginRight: var(--sp1x);
			--registerPopupCheckIconSize: var(--sp1-5x);
			--registerPopupBtnMargin: var(--sp4x) 0 var(--sp7x) 0;
		}
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		:root {
			--registerPopupTitleMargin: var(--sp2x) 0;
			--registerPopupSubtitleMarginBottom: var(--sp1x);
			--registerPopupDescriptionMarginBottom: var(--sp1x);
			--registerPopupContainerPadding: 0;
			--registerPopupFormItemMarginTop: var(--sp3x);
			--registerPopupCheckboxSize: var(--sp2x);
			--registerPopupCheckboxWrapMarginTop: var(--sp3x);
			--registerPopupCheckboxMarginRight: var(--sp1x);
			--registerPopupCheckIconSize: var(--sp1x);
			--registerPopupBtnMargin: var(--sp3x) 0 var(--sp18x) 0;
		}

		.popup-content-container {
			.popup-content-wrap {
				max-height: 100% !important;
				height: 100% !important;
				border-radius: 0 !important;
			}
		}
	}
`}`;

export default RegisterPopupStyle;
